import React from 'react'
import { Steps } from 'antd'

const steps = [{
  key: 'register',
  title: 'Register',
  icon: 'solution'
},
{
  key: 'review',
  title: 'Review',
  icon: 'bars'
}, {
  key: 'pay',
  title: 'Pay',
  icon: 'credit-card'
}, {
  key: 'complete',
  title: 'Complete',
  icon: 'check-circle'
}]

const RegistrationSteps = ({ step }) => {
  const current = steps.findIndex(s => s.key === step)

  return (
    <Steps className="modSteps" current={current}>
      {steps.map(step => <Steps.Step className={step.key} key={step.key} />)}
    </Steps>
  )
}

export default RegistrationSteps



// WEBPACK FOOTER //
// ./src/App/components/RegistrationSteps/RegistrationSteps.js